import type { MelodyPitchId, MelodySoundId } from './melodiaBuilderConfig';

const PITCH_FREQ: Record<MelodyPitchId, number> = {
  Do4: 261.63,
  Re4: 293.66,
  Mi4: 329.63,
  Fa4: 349.23,
  Sol4: 392.0,
  La4: 440.0,
  Si4: 493.88,
  Do5: 523.25,
};

let audioCtx: AudioContext | null = null;

function getCtx(): AudioContext {
  if (!audioCtx) audioCtx = new AudioContext();
  return audioCtx;
}

export async function resumeMelodyAudio(): Promise<void> {
  const ctx = getCtx();
  if (ctx.state === 'suspended') await ctx.resume();
}

export function playMelodyNote(pitchId: MelodyPitchId, soundId: MelodySoundId, when = 0): void {
  const ctx = getCtx();
  const t0 = ctx.currentTime + when;
  const freq = PITCH_FREQ[pitchId];

  const gain = ctx.createGain();
  gain.connect(ctx.destination);

  const osc = ctx.createOscillator();
  osc.frequency.value = freq;
  osc.connect(gain);

  switch (soundId) {
    case 'metalofono':
      osc.type = 'triangle';
      gain.gain.setValueAtTime(0.0001, t0);
      gain.gain.exponentialRampToValueAtTime(0.35, t0 + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.55);
      osc.start(t0);
      osc.stop(t0 + 0.6);
      break;
    case 'flauta':
      osc.type = 'sine';
      gain.gain.setValueAtTime(0.0001, t0);
      gain.gain.exponentialRampToValueAtTime(0.22, t0 + 0.04);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.75);
      osc.start(t0);
      osc.stop(t0 + 0.8);
      break;
    default:
      osc.type = 'sine';
      gain.gain.setValueAtTime(0.0001, t0);
      gain.gain.exponentialRampToValueAtTime(0.28, t0 + 0.008);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.45);
      osc.start(t0);
      osc.stop(t0 + 0.5);
  }
}

export function playMelodyPreview(pitchId: MelodyPitchId, soundId: MelodySoundId): void {
  void resumeMelodyAudio();
  playMelodyNote(pitchId, soundId, 0.02);
}
